import { ModalItemProps } from '@/utils/modalUtil'

interface BuildUnsavedChangesExitModalParams {
  onDiscard: NonNullable<ModalItemProps['onNegative']>
  onSave: NonNullable<ModalItemProps['onPositive']>
}

export function buildUnsavedChangesExitModal({
  onDiscard,
  onSave
}: BuildUnsavedChangesExitModalParams): Partial<ModalItemProps> {
  return {
    title: 'Alterações não salvas',
    positiveColor: 'secondary',
    positiveLabel: 'Salvar e sair',
    negativeLabel: 'Descartar alterações',
    onPositive: onSave,
    onNegative: onDiscard
  }
}
